export interface IDashboard {
  dashboardLoading: boolean;
  dashboardError: boolean;
  nurserySelected: boolean;
}
export const initialState: IDashboard = {
  dashboardLoading: false,
  dashboardError: false,
  nurserySelected: true,
};
